<template>
  <div class="border-grey-divider-subdued border-1 border-solid rounded-lg p-16 bg-grey-background-contrast mt-24">
    <h2 v-if="header" class="text-overline text-grey-header">{{ header }}</h2>
    <p v-if="body" class="text-body-2 mt-4">
      {{ body }}
    </p>
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'NoteBox',
  props: {
    header: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
  },
});
</script>
